import {AfterViewInit, Directive, ElementRef, Input, OnDestroy} from '@angular/core';

@Directive({
  selector: '[siAutofillListener]'
})
export class AutofillListenerDirective implements AfterViewInit, OnDestroy {
  @Input() siAutofillListener: Object;
  @Input() siAutofillListenerProperty: string;
  element: HTMLInputElement;
  private handleInputChange: () => void;

  constructor(
    private el: ElementRef
  ) { }

  ngAfterViewInit(): void {
    // Search input form si-input component
    this.element = this.el.nativeElement.querySelector('input');
    if (!this.element) {
      return;
    }

    // Callback function
    this.handleInputChange = () => this.onAutofill();

    // Check the initial value of the input after a short delay
    setTimeout(() => {
      this.onAutofill();
    }, 100);

    // Add listener with proper context binding
    this.element.addEventListener('input', this.handleInputChange);
  }

  // Auto fill function
  onAutofill(): void {
    if (this.element.value !== '') {
      this.siAutofillListener[this.siAutofillListenerProperty] = this.element?.value;
    }
  }

  ngOnDestroy(): void {
    if (this.element && this.handleInputChange) {
      this.element.removeEventListener('input', this.handleInputChange);
    }
  }
}
